const videoContainer = document.querySelector('.header-video');

if (videoContainer) {
    const fallbackContainer = videoContainer.querySelector('.header-video__fallback-container');
    const videoIframe = videoContainer.querySelector('iframe');
    const playButtons = videoContainer.querySelector('.header-video-buttons');

    const video = document.querySelector('.header-video iframe');

    function updateVideoWidth() {
        if (videoContainer.scrollWidth / videoContainer.scrollHeight >= 16 / 9) {
            video.style.width = '100%';
            video.style.height = 'auto';
        } else {
            video.style.width = 'auto';
            video.style.height = '100%';
        }
    }

    if (video) {
        updateVideoWidth();
        window.addEventListener('resize', () => {
            window.requestAnimationFrame(updateVideoWidth);
        });
    }

    function switchSources(mediaQuery, fallbackImageUri, videoId, onSwitch) {
        if (!window.matchMedia(mediaQuery).matches) {
            return;
        }

        if (!fallbackContainer) {
            console.warn('No fallback container found for header video');
            return;
        }

        if (!videoIframe) {
            console.warn('No video iframe found for header video');
            return;
        }

        if (fallbackImageUri) {
            const newUrl = 'url("' + fallbackImageUri + '")';
            if (fallbackContainer.style.backgroundImage !== newUrl) {
                fallbackContainer.style.backgroundImage = newUrl;
            }
        }

        if (videoId && videoId.trim() !== '') {
            if (videoIframe) {
                videoIframe.style.display = '';
                if (extractVimeoId(videoIframe.src) !== videoId) {
                    videoIframe.src = videoIframe.dataset.src.replace(/video\/\d+/, 'video/' + videoId);
                }
            }
            if (playButtons) {
                playButtons.style.display = 'flex'; // Show the play button
            }
        } else {
            if (videoIframe) {
                videoIframe.style.display = 'none'; // Hide the iframe if videoId is empty
            }
            if (playButtons) {
                playButtons.style.display = 'none'; // Hide the play button
            }
        }

        if (fallbackImageUri && videoId) {
            onSwitch();
        }
    }

    function switchMobile() {
        switchSources(
            '(max-width: 1025px)',
            fallbackContainer.dataset.fallbackImageMobile,
            videoIframe.dataset.videoIdMobile,
            () => videoContainer.classList.add('header-video--mobile')
        );
    }

    function switchDesktop() {
        switchSources(
            '(min-width: 1026px)',
            fallbackContainer.dataset.fallbackImageDesktop,
            videoIframe.dataset.videoIdDesktop,
            () => videoContainer.classList.remove('header-video--mobile')
        );
    }

    let animationFrameId;

    window.addEventListener('resize', () => {
        cancelAnimationFrame(animationFrameId);
        animationFrameId = requestAnimationFrame(() => {
            switchMobile();
            switchDesktop();
        });
    });

    switchMobile();
    switchDesktop();
}

function extractVimeoId(url) {
    const regex = /(?:https?:\/\/)?(?:www\.)?vimeo\.com\/(?:video\/)?(\d+)/;
    const match = url.match(regex);
    return match ? match[1] : null;
}

document.addEventListener('DOMContentLoaded', function () {
    const videoContainer = document.querySelector('.header-video');
    const playButton = document.querySelector('.header-video-button__play');
    const pauseButton = document.querySelector('.header-video-button__pause');
    const video = document.querySelector('.header-video__fallback-container iframe');
    const viewOnButton = document.querySelector('.header-video-button__view-on');
    const viewOffButton = document.querySelector('.header-video-button__view-off');
    const headerBarSticky = document.querySelector('.header-bar-sticky');

    if (!playButton || !pauseButton || !video) {
        return;
    }

    playButton.addEventListener('click', function () {
        video.contentWindow.postMessage('{"method":"play"}', '*');

        playButton.style.display = 'none';
        pauseButton.style.display = 'block';
    });

    pauseButton.addEventListener('click', function () {
        video.contentWindow.postMessage('{"method":"pause"}', '*');

        playButton.style.display = 'block';
        pauseButton.style.display = 'none';
    });

    if (!viewOnButton || !viewOffButton) {
        return;
    }

    viewOnButton.addEventListener('click', function () {
        headerBarSticky.classList.add('active-view-off');
        videoContainer.classList.add('active-view-off');
        viewOnButton.style.display = 'none';
        viewOffButton.style.display = 'block';
    });

    viewOffButton.addEventListener('click', function () {
        headerBarSticky.classList.remove('active-view-off');
        videoContainer.classList.remove('active-view-off');
        viewOffButton.style.display = 'none';
        viewOnButton.style.display = 'block';
    });
});

let prevScrollposHeaderHidden = window.pageYOffset;
let loaded = false;

function hideIllu() {
    const currentScrollPos = window.pageYOffset;
    const headerSticky = document.querySelector('.header-bar-sticky');
    const headerVideoIllu = document.querySelector('.illustration--header-video');

    if (!headerSticky || !headerVideoIllu) return;

    if (!loaded) {
        if (currentScrollPos !== 0) {
            headerVideoIllu.style.display = 'none';
        }
        loaded = true;
    } else {
        if (currentScrollPos <= 120) {
            headerVideoIllu.style.display = 'block';
            headerSticky.classList.remove('illustration--hidden');
        } else {
            headerSticky.classList.add('illustration--hidden');
        }
    }

    prevScrollposHeaderHidden = currentScrollPos;
}

window.addEventListener('scroll', hideIllu, { passive: true });

window.addEventListener('load', () => {
    hideIllu();
});

let sidebarVisible = true;

window.addEventListener('scroll', function () {
    const sidebar = document.querySelector('.header-bar-sticky');
    const footer = document.querySelector('.footer');

    if (sidebar && footer) {
        const windowHeight = window.innerHeight;
        const scrollTop = window.scrollY || document.documentElement.scrollTop;
        const footerTop = footer.offsetTop;

        if (scrollTop + windowHeight >= footerTop) {
            if (sidebarVisible) {
                sidebar.style.display = 'none';
                sidebarVisible = false;
            }
        } else {
            if (!sidebarVisible) {
                sidebar.style.display = 'block';
                sidebarVisible = true;
            }
        }
    }
});
